import React from "react";
import { Container } from 'react-bootstrap';
import {Link} from "react-router-dom";
import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner AI-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">ARTIFICIAL <br />INTELLIGENCE</h2>
						<div className="red-border"> </div>
						<p>digiPanda drives growth and efficiency with advanced Artificial Intelligence (AI) powered applications and intelligent solutions.</p>
						<Link to="/portfolio" className="red-btn"> Explore Our Work </Link>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
